import script from "./new-edit-sms-texts-templates-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-edit-sms-texts-templates-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-edit-sms-texts-templates-modal.vue?vue&type=style&index=0&id=3ddefcf7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddefcf7"]])

export default __exports__